/** @module                     Hooks */

import { useTranslation }       from "react-i18next";

/**
 * 
 * @param { price } param0 
 * 
 * @returns Single product price component
 * 
 */

const Price = ( { price, visualMarkupData } ) => { const { t } = useTranslation ();

    /** Return component */

    return (

        <div className="singleVisualPrice">

            <span className="regularPrice">

                &euro; { parseFloat( price * (1 + (visualMarkupData?.markupPercent || 0) / 100) ).toFixed(2) }

            </span>
            
            <span className="discountedPrice">

                &euro; { price }

            </span>
            
        </div>

    );

}

/** Export component */
 
export default Price;